module.exports = __webpack_public_path__ + "img/de.963c74cf.svg";